import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThumbDislikeFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "thumb dislike 5",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.44171 14.4317H8.45803C8.8046 14.4317 9.03908 14.8245 8.92584 15.1521C8.23547 17.1491 8.03893 21.2341 11.3862 21.2998C11.4391 21.3009 11.4943 21.2915 11.5433 21.2715C12.0466 21.066 12.1727 20.8108 12.2786 20.313C12.9533 17.2717 14.4237 15.5946 15.7623 14.9325C15.8358 14.8961 15.8552 14.8047 15.8185 14.7313C15.3968 13.9546 15.3968 13.2 15.3968 11.9461V5.78735C15.3968 5.21548 15.3968 4.7451 15.4391 4.32865C15.4594 4.12802 15.3582 3.93018 15.1741 3.84783C14.2359 3.42812 13.2573 3.06864 12.2786 3.06864H7.32945C4.47758 3.06864 2.50235 4.9218 2.50235 7.98451C2.50235 11.1915 2.26932 14.4317 6.44171 14.4317Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.2265 14.7979C18.576 14.9588 19.7401 14.9899 20.7831 14.9965C21.1793 14.9988 21.5 14.677 21.5 14.2819V3.41484C21.5 3.01868 21.1793 2.69799 20.7831 2.70021C19.7401 2.70576 18.576 2.73683 18.2265 2.89884C17.8159 3.08748 17.483 3.3871 17.2832 3.76439C17.0613 4.16387 17.0613 4.69652 17.0613 5.75071V11.946C17.0613 13.0002 17.0613 13.5329 17.2832 13.9324C17.483 14.3096 17.8159 14.6093 18.2265 14.7979Z",
		fill: "currentColor"
	})]
});
export default SvgThumbDislikeFill;
